import { ref } from 'vue';
import { createSharedComposable, tryOnBeforeMount } from '@vueuse/core';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { useCommands } from '@telecom/shared/composables/use-commands';

interface OpenLoginDialogPayload {
    /** 登录页面 URL */
    loginUrl?: string;
    /** 触发来源 */
    trigger_source?: string;
}

/**
 * 用户登录状态 composable
 * 提供全局共享的用户登录状态
 */
export const useLogin = createSharedComposable(() => {
    const { executeCommand } = useCommands();
    const isLogin = ref(false);

    tryOnBeforeMount(async () => {
        isLogin.value = await isUserLogin();
    });

    function openLoginDialog(options?:OpenLoginDialogPayload) {
        executeCommand('login:open-dialog', options);
    }
    return { isLogin, openLoginDialog };
});
